import { makeStyles } from '@policygenius/mortar';

type Classes = 'header' | 'logo' | 'nav' | 'chatIcon' | 'phoneIcon';

interface Options {
  isAccountHolder: boolean;
}

export default makeStyles<Options, Classes>(({ breakpoints, spacing }) => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '60px',
    padding: [0, '3rem'],
    [`@media only screen and (max-width: ${breakpoints.medium - 1}px)`]: {
      paddingLeft: spacing('large'),
      paddingRight: ({ isAccountHolder }) => (isAccountHolder ? 0 : spacing('medium')),
    },
  },
  logo: {
    width: '147px',
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,

    // accounts for some slight layout shift between this nav and the old DI nav
    // can be removed after migration is done
    marginTop: '-2px',
  },
  chatIcon: {
    marginRight: spacing('large'),
  },
  phoneIcon: {
    marginTop: '4px',
  },
}));
